export default __webpack_public_path__ + "static/media/icon_organized.d28ff448.svg";